import { Link } from 'react-router-dom';

interface PublicHeaderProps {
  showAuthLinks?: boolean;
}

const PublicHeader: React.FC<PublicHeaderProps> = ({ showAuthLinks = true }) => {
  return (
    <header className="bg-white dark:bg-gray-900 shadow-sm">
      <div className="max-w-6xl mx-auto px-2 sm:px-4 lg:px-6 py-2 sm:py-3 lg:py-4">
        <div className="flex items-center justify-between min-w-0">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-1 sm:space-x-2 hover:opacity-80 transition-opacity flex-shrink-0">
            <img src="/apple-touch-icon.png" alt="EightyThreeLabs" className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8" />
            <span className="text-sm sm:text-lg lg:text-xl font-semibold">
              <span className="text-brand-primary">EightyThree</span>
              <span className="text-black dark:text-white">Labs</span>
            </span>
          </Link>
          
          {/* Auth Navigation */}
          {showAuthLinks && (
            <div className="flex items-center gap-2 sm:gap-3 lg:gap-4 flex-shrink-0">
              <Link 
                to="/login" 
                className="text-xs sm:text-base text-gray-600 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white font-medium transition-colors px-2 sm:px-0"
              >
                <span className="hidden sm:inline">Sign In</span>
                <span className="sm:hidden">Login</span>
              </Link>
              <Link 
                to="/signup" 
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-3 sm:px-4 lg:px-6 py-1.5 sm:py-2 rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all font-medium shadow-md text-xs sm:text-base whitespace-nowrap"
              >
                <span className="hidden sm:inline">Get Started</span>
                <span className="sm:hidden">Start</span>
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;